import Button from "@pathwright/ui/src/components/button/Button"
import ButtonGroup from "@pathwright/ui/src/components/button/ButtonGroup"
import IconButton from "@pathwright/ui/src/components/button/IconButton"
import OutsideClickWrapper from "@pathwright/ui/src/components/overlay/OutsideClickWrapper"
import PropTypes from "prop-types"
import { useState } from "react"
import styled from "styled-components"
import { useEditPathContext } from "./EditPath"
import EditPathAddResource from "./EditPathAddResource"
import EditPathLessonForm from "./EditPathLessonForm"

const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`
const FormWrapper = styled.div`
  margin: 1em auto 0;
  width: 100%;
  max-width: 800px;
  padding: 0 10px;
`
const Toggle = styled.div`
  position: relative;
  height: 0;
`
const AddButton = styled(IconButton)`
  display: block !important;
  margin: 0 auto;
  transform: translateY(-50%);
  z-index: 1;
`

const AddButtonGroup = styled(ButtonGroup)`
  margin-top: 1em;
`

const EditPathAddItem = ({ index, pathId }) => {
  const [lesson, setLesson] = useState(false)
  const [picking, setPicking] = useState(false)

  const { addingAtIndex, setAddingAtIndex } = useEditPathContext()

  const toggleOpen = () => {
    if (addingAtIndex === index) {
      setLesson(false)
      setAddingAtIndex(null)
    } else {
      setAddingAtIndex(index)
    }
  }

  const isOpen = addingAtIndex === index

  return (
    <OutsideClickWrapper
      mouseEvent="mouseup"
      shouldListen={isOpen && !picking}
      onOutsideClick={toggleOpen}
    >
      <Wrapper>
        <Toggle>
          <AddButton
            icon="plus-circle"
            onClick={toggleOpen}
            rotate={isOpen ? 45 : 0}
            styleType="blank"
            size={30}
            inverted
          />
        </Toggle>
        {isOpen && lesson && (
          <FormWrapper>
            <EditPathLessonForm
              index={index}
              pathId={pathId}
              onClose={toggleOpen}
            />
          </FormWrapper>
        )}
        {isOpen && !lesson && (
          <AddButtonGroup border={false}>
            <Button
              styleType="secondary"
              onClick={() => setLesson(true)}
              size="large"
              inverted
            >
              Add a group
            </Button>
            <EditPathAddResource
              index={index}
              pathId={pathId}
              inverted
              handlePicking={(picking) => setPicking(picking)}
            />
          </AddButtonGroup>
        )}
      </Wrapper>
    </OutsideClickWrapper>
  )
}

EditPathAddItem.displayName = "EditPathAddItem"

EditPathAddItem.propTypes = {
  index: PropTypes.number.isRequired,
  pathId: PropTypes.number.isRequired
}

export default EditPathAddItem
